import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReviewEntryDataFormFieldList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S32};
`

export const ReviewEntryDataFormFieldsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S16};
`

export const ReviewEntryDataFormInvoiceNumberWrapper = styled.div`
  width: 180px;
`

export const ReviewEntryDataFormDatesRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${Spacing.S16};
  justify-content: space-between;
`

export const ReviewEntryDataFormDateGroup = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${Spacing.S16};
`

export const ReviewEntryDataFormSupplierSelect = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  max-width: 600px;
`
